<template>
  <div class="app-container">
    <van-cell-group class="user-info-cell-group">
      <van-cell to="user/info" :border="false" :is-link="true" class="user-info-cell">
        <van-image
          slot="icon"
          width="64"
          height="64"
          fit="cover"
          :src="require('@/assets/images/head.jpg')"
          class="avatar"
        >
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
        <div slot>
          <div v-if="isAuthenticated" class="name">
            {{ webUserInfo.realName }}
            <van-tag type="success" size="medium">
              已认证
            </van-tag>
          </div>
          <div v-else class="name">
            {{ weChatUserInfo.nickName }}
            <van-tag type="danger" size="medium">
              未认证
            </van-tag>
          </div>
          <div class="phone-number">
            手机号：{{ webUserInfo.mobilePhone }}
          </div>
        </div>
      </van-cell>
    </van-cell-group>
    <van-cell-group class="modules-cell-group">
      <van-cell title="我的消息" size="large" :is-link="true">
        <van-icon
          slot="icon"
          class="left-icon"
          name="email"
          color="#FEC22D"
          size="24px"
          class-prefix="iconfont"
        />
      </van-cell>
      <van-cell
        title="我的申请"
        size="large"
        :to="{name:'WebApplicationList'}"
        :is-link="true"
        v-if="qxdm=='360983'"
      >
        <van-icon
          slot="icon"
          class="left-icon"
          name="order"
          color="#07C160"
          size="24px"
          class-prefix="iconfont"
        />
      </van-cell>
      <van-cell
        title="我的申请"
        size="large"
        :to="{name:'WebApplicationList'}"
        :is-link="true"
        v-else
      >
        <van-icon
          slot="icon"
          class="left-icon"
          name="order"
          color="#07C160"
          size="24px"
          class-prefix="iconfont"
        />
      </van-cell>
      <van-cell title="我的预约" size="large" :is-link="true">
        <van-icon
          slot="icon"
          class="left-icon"
          name="task-management"
          color="#FA9D3B"
          size="24px"
          class-prefix="iconfont"
        />
      </van-cell>
      <!-- <van-cell title="我的咨询" size="large" :is-link="true">
        <van-icon
          slot="icon"
          class="left-icon"
          name="comments"
          color="#F75356"
          size="24px"
          class-prefix="iconfont"
        />
      </van-cell> -->
    </van-cell-group>
    <van-cell-group>
      <!-- <van-cell
        :to="{path:'/other/suggestion'}"
        title="意见反馈"
        value="填写反馈"
        size="large"
        :is-link="true"
      >
        <van-icon
          slot="icon"
          class="left-icon"
          name="suggest"
          color="#1485EE"
          size="24px"
          class-prefix="iconfont"
        />
      </van-cell> -->
      <van-cell
        title="关于我们"
        value="平台信息"
        size="large"
        :is-link="true"
      >
        <van-icon
          slot="icon"
          class="left-icon"
          name="prompt"
          color="#1485EE"
          size="24px"
          class-prefix="iconfont"
        />
      </van-cell>
      <van-cell
        title="设置"
        value="系统设置"
        size="large"
        :is-link="true"
      >
        <van-icon
          slot="icon"
          class="left-icon"
          name="set"
          color="#1485EE"
          size="24px"
          class-prefix="iconfont"
        />
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { AppAuthLevel } from '@/utils/enums'
import { getSystemConfig } from '@/api/systemConfig.js'

export default {
  data() {
    return {
      qxdm: null
    }
  },
  computed: {
    ...mapGetters(['userAuthLevel', 'weChatUserInfo', 'webUserInfo']),
    isAuthenticated: function() {
      return this.userAuthLevel === AppAuthLevel.AUTHENTICATED_USER.value
    }
  },
  methods: {
    // 获取系统配置（区县代码）
    loadSystemConfig() {
      getSystemConfig({
        'key': 'DJXT_QXDM'
      }).then(response => {
        this.qxdm = response.data.value
      })
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  min-height: 100vh;
  background-color: #ededed;
  .user-info-cell-group {
    margin-bottom: 10px;
    .user-info-cell {
      padding: 30px 15px;
      .avatar {
        margin-right: 15px;
        border-radius: 5px;
        overflow: hidden;
      }
      .name {
        height: 40px;
        line-height: 40px;
        color: #181818;
        font-size: 20px;
        font-weight: 700;
      }
      .phone-number {
        color: #7f7f7f;
      }
      .van-cell__right-icon {
        margin-top: 40px;
      }
    }
  }
  .modules-cell-group {
    margin-bottom: 10px;
  }

  .van-cell:not(:last-child)::after {
    left: 54px;
    border-bottom: 1px solid #d9d9d9;
  }
}
</style>
